export default __webpack_public_path__ + "static/media/sc23.84595d24.jpg";